import { Injectable, OnDestroy, Inject, InjectionToken } from '@angular/core';
import { LabTestResult, LabResultsStorage, UnitOption } from '../../lab-test-results';
import { ActivatedRoute } from '@angular/router';
import { Observable, ConnectableObservable, Subscription, combineLatest } from 'rxjs';
import { map, filter as rxFilter, publishReplay, refCount, switchMap, takeWhile, tap, distinctUntilChanged } from 'rxjs/operators';
import { CovanceFilter } from '../../covance-filter/covance-filter';
import { Site } from '../../sites/site';
import { FilterFieldValue, } from '../../covance-filter/covance-filter.models';
import { FilterStorage } from './lab-test-results-filter-storage';
import { SiteTestDataStorage } from './site-test-data-storage';
import { routeData } from '../../shared/route-helpers';
import { UnitStorage } from '../../user/unit-storage';
import { LOAD_ALL_RESULTS_QUERY_PARAMETER } from './standart-test-result-query-parameters';

export const SITE_LAB_RESULTS_FILTERS_STORAGE = new InjectionToken<FilterStorage>('SiteLabResultsFiltersStorageToken');

@Injectable()
export class FilteredLabTestResultsStorage implements SiteTestDataStorage, OnDestroy {

    private readonly results: ConnectableObservable<LabTestResult[]>;

    private filterFieldVals: FilterFieldValue[];

    private connection: Subscription;

    constructor(
        labResultsStorage: LabResultsStorage,
        unitStorage: UnitStorage,
        route: ActivatedRoute,
        private readonly filter: CovanceFilter,
        @Inject(SITE_LAB_RESULTS_FILTERS_STORAGE) filterStorage: FilterStorage,
    ) {
        const site = route.parent.parent.data
            .pipe(
                map(x => (x[routeData.selectedSite] as Site)),
                rxFilter(x => !!x),
                publishReplay(1),
                refCount(),
                );

        const loadAll$ = site
            .pipe(
                switchMap(() => route.queryParams),
                map((p) => !!p[LOAD_ALL_RESULTS_QUERY_PARAMETER]),
                distinctUntilChanged(),
                takeWhile( v => !v, true),
                );

        const siteLabResults = combineLatest([
            unitStorage.currentUnit,
            labResultsStorage.getSiteLabResultsRestricted(site, loadAll$),
        ]).pipe(
            map((data: [UnitOption, LabTestResult[]]) => {
                const [unitOption, res] = data;
                let result: LabTestResult[] = null;
                if (res) {
                    result = res.map(r => {
                        r.showResultsInSI = unitOption.isSiUnit;
                        return r;
                    });
                }
                return result;
            }),
        );

        this.filterFieldVals = filterStorage.filterFieldsData; // this.filterFieldDefs.map(def => { return { def: def } as FilterFieldValue; });
        this.results = this.filter.getFilteredData(siteLabResults, this.filterFieldVals).pipe(publishReplay(1)) as ConnectableObservable<LabTestResult[]>;
        this.connection = this.results.connect();
    }

    public get getData(): Observable<LabTestResult[]> {
        return this.results;
    }

    public ngOnDestroy(): void {
        this.connection.unsubscribe();
    }
}

export class TestFilterItem {
    constructor(public zcTestCode: string, public testTitle: string) {
    }

    public toString() {
        return this.testTitle;
    }
    public get key() {
        return this.zcTestCode;
    }
}
